export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-page-calendar/index.js